import React, { useContext } from 'react';
import { Alert } from 'antd';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Icon } from 'components';
import { featureEnabled } from 'utils';
import { SupraSystemSubscriptionStatus } from '@bb/domain/dist/types';
import { SupraCoopType } from '@bb/domain/dist/types/SupraSystemSubscription';
import MLSUserPageContext from './MLSUserPageContext';
import { Section } from './styles';

const LockboxReturnBanner = ({ lockboxSection }: { lockboxSection: any }) => {
  const { user, lockboxesCount, subscriptions } =
    useContext(MLSUserPageContext);

  if (
    featureEnabled('supraAutoCoopFeature') &&
    user?.coopType !== SupraCoopType.PRIMARY
  )
    return null;

  const scrollToLockboxSection = () => {
    if (lockboxSection) {
      lockboxSection.scrollIntoView({ behavior: 'smooth' });
    }
  };
  if (
    !lockboxesCount ||
    (lockboxesCount &&
      subscriptions.supra.status ===
        SupraSystemSubscriptionStatus.subscribed) ||
    !subscriptions?.supra?.history?.some(
      ({ action }) => action === 'subscribed',
    )
  )
    return null;
  return (
    <Section>
      <Alert
        type="error"
        showIcon
        icon={<Icon type="antdWarningFilled" color="errorColor" width={14} />}
        message={
          <StyledAlertMessageContainer>
            <span>This user has lockboxes they haven&apos;t returned yet.</span>
            <Link to="#" onClick={scrollToLockboxSection}>
              View lockboxes
            </Link>
          </StyledAlertMessageContainer>
        }
        style={{ width: '100%' }}
      />
    </Section>
  );
};
const StyledAlertMessageContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;
export default LockboxReturnBanner;
